/**
 * OVA — Collection page filter allowlist.
 *
 * Product requirement: only "Color", "Weight", and "Price" filters should be
 * shown in the collection filter drawer; every other filter group
 * (Availability, Category, etc. — whatever is configured in
 * Search & Discovery) should be hidden from shoppers.
 *
 * Implemented client-side rather than editing snippets/facets.liquid
 * directly because Shopify's facet drawer re-renders its markup via AJAX
 * on every filter/sort/pagination change (the theme replaces
 * #FacetsWrapperMobile / #FacetsWrapperDesktop innerHTML from the fetched
 * partial), so a one-time template tweak would only hold until the first
 * filter interaction. A MutationObserver re-applies the same allowlist
 * after every re-render instead, and this stays correct automatically if
 * filters are ever added/removed/renamed in Search & Discovery — no
 * per-filter param name to keep in sync.
 */
(function () {
  var ALLOWED_LABELS = ['color', 'weight', 'price'];

  function normalizedLabel(detailsEl) {
    var labelEl =
      detailsEl.querySelector('.mobile-facets__summary span') ||
      detailsEl.querySelector('.facets__summary-label') ||
      detailsEl.querySelector('summary span');
    if (!labelEl) return '';
    // Strip the trailing " (n)" active-count badge some summaries render.
    return labelEl.textContent.replace(/\s*\(\d+\)\s*$/, '').trim().toLowerCase();
  }

  function applyAllowlist(root) {
    var scope = root || document;
    var detailsEls = scope.querySelectorAll(
      '.mobile-facets__details, .facets__disclosure-vertical, .facets_item.disclosure-has-popup.facets__disclosure'
    );
    detailsEls.forEach(function (el) {
      var label = normalizedLabel(el);
      if (!label) return;
      var shouldShow = ALLOWED_LABELS.indexOf(label) !== -1;
      el.style.display = shouldShow ? '' : 'none';
    });
  }

  function init() {
    applyAllowlist(document);

    var watchTargets = [
      document.getElementById('FacetsWrapperMobile'),
      document.getElementById('FacetsWrapperDesktop'),
      document.getElementById('main-collection-filters')
    ].filter(Boolean);

    if (!watchTargets.length || !('MutationObserver' in window)) return;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        applyAllowlist(document);
      });
    });

    watchTargets.forEach(function (target) {
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
